// Fix oversized product gallery
(function() {
  function fixGallery() {
    var media = document.querySelector('.product__media.media');
    if (!media) return;
    
    // Override Dawn's baked-in aspect ratio padding
    // Use a fixed height that looks good for product images
    media.style.paddingTop = '0';
    media.style.height = '360px';
    media.style.position = 'relative';
    
    // Make the absolutely-positioned child image fill the container
    var img = media.querySelector('img');
    if (img) {
      img.style.position = 'absolute';
      img.style.top = '0';
      img.style.left = '0';
      img.style.width = '100%';
      img.style.height = '100%';
      img.style.objectFit = 'contain';
    }
    
    // Constrain wrapper width
    var wrapper = document.querySelector('.product__media-wrapper');
    if (wrapper) {
      wrapper.style.maxWidth = '440px';
    }
  }
  fixGallery();
  new MutationObserver(fixGallery).observe(document.body, {childList: true, subtree: true});
})();
